import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EditorModule } from 'src/app/editor/editor.module';
import { FormHelperModule } from 'src/app/shared/form/form-hepler.module';
import { DomSanitizer } from '@angular/platform-browser';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { RESPONSE_CODE } from 'src/app/helper/class/app-constant';
import {
  cloneData,
  isArray,
  isEmptyObj,
} from 'src/app/helper/class/utilityHelper';
import {
  formBuilderData,
  ResponseData,
} from 'src/app/helper/interface/response';
import { AlertService } from 'src/app/helper/service/alert.service';
import { EmailApiService } from 'src/app/modules/email/service/email-api.service';
import { EMAIL_TEMP_FORM } from 'src/app/modules/master/config/config';
import { FormDocComponent } from 'src/app/shared/form/component/form-doc/form-doc.component';
import { FormGeneratorComponent } from 'src/app/shared/form/component/form-generator/form-generator.component';
import { ModalService } from 'src/app/shared/service/modal.service';
import { environment } from 'src/environments/environment';
import { ImageUploadModule } from 'src/app/shared/shared.module';
import { ImageUploadComponent } from '../image-upload/image-upload.component';

export interface emailConfigData {
  config?: config;
  body: any;
  subject?: any;
  cc?: any;
  bcc?: any;
  replaceKey?: any;
  pdf_content?: any;
  mode?: 'EMAIL' | 'SMS' | 'WHATSAPP';
  type?: 'PREVIEW' | 'SEND' | 'VIEW';
  id?: string | number;
  payload?: any;
  to?: string;
  sentBtnShow?: boolean;
  attachment?: Array<any>;
}
interface config {
  is_preview?: boolean;
  is_pdf?: boolean;
  is_sent?: boolean;
}
@Component({
  selector: 'app-email-sender',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    EditorModule,
    FormHelperModule,
    ImageUploadModule
  ],
  templateUrl: './email-sender.component.html',
  styleUrls: ['./email-sender.component.scss'],
})
export class EmailSenderComponent implements OnInit {
  mode: 'EMAIL' | 'SMS' | 'WHATSAPP' = 'EMAIL';
  type: 'PREVIEW' | 'SEND' | 'VIEW' = 'VIEW';
  formData: emailConfigData = {} as emailConfigData;
  config: config = {};
  isModal: boolean = false;
  dataLoading: boolean = false;
  iframeLoad: boolean = false;
  pdf_url: any = `${environment.apiUrl}${environment.emailApiUrl}/printpdf/`;
  emailData: any = {}
  sentBtnShow: boolean = false;
  loading: boolean = false;
  public onClose: Subject<any> = new Subject();
  @ViewChild('basicForm') basicForm: FormGeneratorComponent | undefined;
  @ViewChild('docForm') docForm: FormDocComponent | undefined;
  @ViewChild('imageUploader') imageUploader: ImageUploadComponent | undefined;
  title: string = '';
  BASIC_FORM_BUILDER: formBuilderData[] = cloneData(EMAIL_TEMP_FORM)
    ?.slice(3)
    .filter((a: any) => a.colName != 'allow_email' && a.colName != 'allow_to_send_email');
  constructor(
    private sanitizer: DomSanitizer,
    private emailApi: EmailApiService,
    private _bsModalRef: BsModalRef,
    private modalService: ModalService,
    private alertService: AlertService
  ) { }

  ngOnInit(): void { }

  setInput(data: emailConfigData) {
    if (!isEmptyObj(data)) {
      this.isModal = true;
      console.log("data", data);

      if (data.type) {
        this.type = data.type;
      }
    }
    // this.mode = data.config?.is_pdf ? 'PDF' : 'EMAIL';
    this.sentBtnShow = data?.sentBtnShow || false;
    if (data.config?.is_pdf && data.pdf_content) {
      this.type = data.config.is_preview ? 'PREVIEW' : 'VIEW';
      this.getPreviewPdf(data.pdf_content);
    } else if (data.payload && data.id) {
      this.title = this.type == 'SEND' ? 'Send Email' : 'Preview';
      // this.type =
      //   this.mode == 'PDF' && data?.config?.is_preview ? 'PREVIEW' : this.type;
      this.genEmail(data.id, data.payload); //post data on data body
    } else if (data.id && !data.body) {
      this.type = data?.config?.is_preview ? 'PREVIEW' : 'VIEW';
      this.title = 'Log Info';
      this.getEmail(data.id);
      return;
    }
    if (this.type == 'SEND') {
      this.sentBtnShow = true;
      this.emailData.receiver = data.to
      this.getEmailGeneralContent()
    }
    this.title = this.title
      ? this.title
      : this.mode.toLowerCase() + ' ' + this.type.toLocaleLowerCase();
    this.formData = data;
    if (data.type == 'SEND' && data.to) {
      setTimeout(() => {
        if (data.to) {
          let to: any = data.to;
          if (typeof data.to == 'string') {
            to = data.to?.split(',');
          }
          this.basicForm?.setValue('to', to);
        }
        if (isArray(data?.attachment)) {
          this.docForm?.setData(data.attachment);
        }
      }, 800);
    }
    if (this.formData.body) {
      this.mapKeyValue();
    }
  }

  getEmailGeneralContent() {
    this.emailApi.getEmailGeneralContent().then((res: ResponseData | any) => {
      if (res.statusCode == RESPONSE_CODE.SUCCESS) {
        this.formData.body = res.result?.body || this.formData.body;
        this.basicForm?.setData(res.result);
      }
    })
  }

  getEmail(id: string | number) {
    this.dataLoading = true;
    this.emailApi
      .getEmailById(id)
      .then((res: ResponseData | any | any) => {
        if (res.statusCode == RESPONSE_CODE.SUCCESS) {
          this.emailData = res.result;
          // if (this.emailData?.attachment_path) {
          //   this.emailData.attachment_path[1] = this.emailData?.attachment_path[0]
          // }
        } else {
          this.alertService.showToast('Unable to get the Email', 'error');
        }
      })
      .catch((err: any) => {
        this.alertService.showToast('Unable to complete', 'error');
      })
      .finally(() => (this.dataLoading = false));
  }

  onChange(e: any) { }
  getSafeUrl(url: any) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  previewPayload = {};
  moduleId: any = '';
  genEmail(id: string | number, payload: any): any {
    console.log('id', id, ' Payload', payload, this.type, this.mode);
    this.previewPayload = payload;
    this.moduleId = id;
    // if (this.type == 'PREVIEW' && this.mode == 'PDF') {
    //   return this.getPreviewPdf(payload, id);
    // }

    this.dataLoading = true;
    this.emailApi
      .generateEmail(id, payload)
      .then((res: ResponseData | any) => {
        if (res.result) {
          this.emailData = res.result;
          if (this.formData.to) {
            res.result.to = res.result.to
              ? res.result.to + ',' + this.formData.to
              : this.formData.to;
          }
          this.basicForm?.setData(res.result);
          this.formData.body = res.result.body;
        }
      })
      .finally(() => (this.dataLoading = false));
  }
  async getPreviewPdf(data: any, id: string | number = '') {
    this.iframeLoad = true;
    data = await this.sanitizer.bypassSecurityTrustHtml(data);
    if (data.hasOwnProperty('changingThisBreaksApplicationSecurity')) {
      data = data['changingThisBreaksApplicationSecurity'];
    }
    let payload: any = {};
    if (!id) {
      payload.pdf_content = data;
    } else {
      payload = data;
    }
    this.emailApi
      .showPdf(payload, id)
      .then((res: any) => {
        const blob = new Blob([res], { type: 'application/pdf' });
        this.pdf_url = this.getSafeUrl(URL.createObjectURL(blob));
      })
      .finally(() => (this.iframeLoad = false));
  }

  showPdfPreview() {
    this.modalService.openModal(
      EmailSenderComponent,
      {
        pdf_content: this.emailData.pdf_content,
        config: { is_preview: true, is_pdf: true },
      },
      'modal-lg',
      2
    );
  }

  mapKeyValue() {
    if (this.formData.replaceKey) {
      Object.keys(this.formData.replaceKey).forEach((a: any) => {
        this.formData.body.replace(`{${a}}`, this.formData.replaceKey[a]);
        this.formData?.subject.replace(`{${a}}`, this.formData.replaceKey[a]);
      });
    }
  }

  payload() {
    let payload = this.basicForm?.apiPayload() || this.emailData;
    payload.body = this.formData.body;
    console.log("payload1", this.formData, payload);
    payload.receiver = this.emailData.receiver
    payload.attachment = this.docForm?.apiPayload() || [];
    return payload;
  }

  send() {
    this.loading = true;
    if (!this.emailData.receiver && !this.formData.body) {
      this.alertService.showToast('Receiver email is required', 'error');
      this.loading = false;
      return;
    }
    this.emailApi
      .sendEmailByData(this.payload())
      .then((res: ResponseData | any) => {
        this.close({ emailSend: true });
      })
      .finally(() => (this.loading = false))
  }

  onChangeContent(ev: any) {
    const dat = ev.target.innerHTML || '';
    if (this.formData.config?.is_pdf) {
      this.formData.pdf_content = dat;
    } else {
      this.formData.body = dat; //this.getSafeHtml(dat);
    }
  }
  close(data: any = false) {
    this._bsModalRef.hide();
    this.onClose.next(data || this.formData);
  }
}
